import { Model } from 'vuex-orm';

import Company from '../company/model';
import App from '../app/model';
import User from '../user/model';
import Role from '../role/model';

export default class UserMembership extends Model {
  static entity = 'userMemberships';

  static fields() {
    return {
      id: this.attr(null),
      company_id: this.attr(null),
      app_id: this.attr(null),
      user_id: this.attr(null),
      role_id: this.attr(null),
      invitation_email: this.attr(''),
      invitation_sent_at: this.attr(''),
      invitation_expires_at: this.attr(''),
      invitation_accepted_at: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),
      timezone: this.attr(''),

      company: this.belongsTo(Company, 'company_id'),
      app: this.belongsTo(App, 'app_id'),
      user: this.belongsTo(User, 'user_id'),
      role: this.belongsTo(Role, 'role_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/userMembership/model.js